/*!

=========================================================
* Argon Dashboard PRO React - v1.2.5
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import PrivacyPolicy from "pages/PrivacyPolicy";
import TermsOfService from "pages/TermsOfService";
import ThankYou from "pages/ThankYou";

const routes = [
  {
    show: false,
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    icon: "ni ni-ungroup text-orange",
    component: PrivacyPolicy,
    layout: "/",
  },
  {
    show: false,
    path: "/terms-of-service",
    name: "TermsOfService",
    icon: "ni ni-ungroup text-orange",
    component: TermsOfService,
    layout: "/",
  },
   {
    show: false,
    path: "/logout",
    name: "Logout",
    icon: "ni ni-ungroup text-orange",
    component: ThankYou,
    layout: "/",
  },
];

export default routes;
